import useGlobal from '@/hooks/useGlobal'
import serviceApi from '@/state/service/service.slice'

/**
 * Fetches the list of available data providers and their metadata from the API.
 * Returns provider IDs, their labels, and descriptions for UI display.
 */
export function useSupportedDataProviders() {
  const { orgId } = useGlobal()
  const {
    data = {
      data_providers: [],
      data_providers_meta: {} as Record<
        string,
        { label: string; description: string }
      >,
    },
    isLoading,
    error,
  } = serviceApi.useGetSupportedDataProvidersQuery({ orgId })

  return {
    providers: data.data_providers,
    metadata: data.data_providers_meta,
    isLoading,
    error,
  }
}
